export const PROPERTY_TEMPLTES = [
  {
    label: 'In Progress / Done',
    value: 'plan_inprogress_done_type',
  },
  {
    label: 'Submit / Approve / Reject',
    value: 'plan_submit_approve_reject_type',
  },
  {
    label: 'Pass / Fail',
    value: 'plan_pass_fail_type',
  },
  {
    label: 'Percentage Progress',
    value: 'percentage_progress_type',
  },
]
